import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/portal/announcements/active — the single active announcement that
// matches the viewing partner's audience scopes (tier + partner_type). The
// route returns null when nothing matches; the dashboard hides the strip.
export type ActiveAnnouncement = {
  id: string;
  body: string;
  active: boolean;
  starts_at: string | null;
  ends_at: string | null;
  audience_segment_id: string | null;
  tier_scope: string[] | null;
  partner_type_scope: string[] | null;
  created_by: string | null;
  created_at: string;
};

export function useActiveAnnouncement() {
  return useQuery<ActiveAnnouncement | null, ApiClientError>({
    queryKey: queryKeys.portal.announcement(),
    queryFn: () => apiFetch<ActiveAnnouncement | null>("/portal/announcements/active"),
  });
}
